import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import CheckIc from '../../assets/images/ic_check.svg';
import UncheckIc from '../../assets/images/ic_uncheck.svg';

function CheckBox({
  id = null,
  value,
  isChecked,
  onChange,
  label = null,
  checkStyle = {},
  labelStyle = {},
  boxStyle = {},
  checkedIcon = CheckIc,
  uncheckedIcon = UncheckIc,
  disabled = false,
}) {
  const inputRef = useRef(null);

  return (
    <div className="text-ellipsis overflow-hidden flex" style={boxStyle}>
      <button
        type="button"
        onClick={() => inputRef.current.click()}
        style={{ verticalAlign: 'middle' }}
        disabled={disabled}
      >
        <img
          src={isChecked ? checkedIcon : uncheckedIcon}
          alt="check"
          style={{
            marginRight: '5px',
            width: '25px',
            height: '25px',
            ...checkStyle,
          }}
        />
        <input
          ref={inputRef}
          type="checkbox"
          id={id}
          value={value}
          checked={isChecked}
          onChange={e => onChange(e.target.checked, id)}
          style={{ display: 'none' }}
        />
      </button>
      {label && (
        <div
          className="truncate overflow-hidden whitespace-nowrap"
          style={{
            ...labelStyle,
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
}

CheckBox.propTypes = {
  id: PropTypes.any,
  value: PropTypes.any.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  checkStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  boxStyle: PropTypes.object,
  checkedIcon: PropTypes.string,
  uncheckedIcon: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CheckBox;
